import { Injectable } from '@angular/core';
import { HomeRepository } from '@data/repository/home/home.repository';
import { CidadeEntity } from '@domain/dto/cidade/cidade-get.dto';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class HomeUsecase {
  constructor(private repository: HomeRepository) {}

  get(): Observable<CidadeEntity> {
    return this.repository.get();
  }


}
